import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CREATE_BUDGET_PATH, CREATE_CLIENT_PATH } from '../../contants';
import { addClient, setCurrentStep } from '../../features/createBudget/createBudgetSlice';
import useClientOptions from '../../hooks/createBudgets/useClientOptions';
import Button from '../reusable/Button/Button';
import Select from '../reusable/Select/Select';
import css from './SelectClient.module.css';

const SelectClient = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { formData } = useSelector(state => state.createBudget);
  const { client: selectedClient } = formData;

  const { clientOptions, isClientsLoading } = useClientOptions();

  const handleCreateClient = useCallback(() => {
    navigate(CREATE_CLIENT_PATH);
  }, [navigate]);

  const handleClientChange = useCallback((nextClient) => {
    if (!nextClient) return;
    dispatch(addClient(nextClient));
    dispatch(setCurrentStep(2));
    navigate(`${CREATE_BUDGET_PATH}/budget`);
  }, [dispatch, navigate]);

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1 className={css.title}>Select a Client</h1>
        <Button
          styled="addClient"
          title="Create New Client"
          onClick={handleCreateClient}
        />
      </div>

      <p className={css.text}>
        Clients can have multiple budgets across multiple channels. Select an
        existing client below or create a new client.
      </p>

      <h2 className={css.select}>Client</h2>
      <Select
        options={clientOptions}
        value={selectedClient || ''}
        placeHolder={isClientsLoading ? 'Loading clients…' : 'Select Client'}
        disabled={isClientsLoading}
        onChange={handleClientChange}
      />
    </div>
  );
};

export default SelectClient;